
import { Component, Mixins, Watch, Emit } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
import { namespace } from "vuex-class";
import vselect3 from "vselect3";

import AlarmActionsMixin from "@/mixins/AlarmActionsMixin";
import { Contact } from "@/store/user-management/types";

const UserManagement = namespace("userManagement");

@Component({
	components: {
		"v-select-3": vselect3
	},
	validations: {
		currentAlarmAction: { objectID: { required } },
		hasDataChanged: {
			required: requiredIf(function() {
				return this.currentAlarmAction.objectID === this.originalObjectId;
			})
		}
	}
})
export default class ActionSetupSendEmail extends Mixins(AlarmActionsMixin, validationMixin) {
	@UserManagement.State private contacts: Contact[];

	private originalObjectId: number = null;

	public created(): void {
		if (this.isEditing) {
			this.originalObjectId = this.currentAlarmAction.objectID;
		}
	}
}
